import { connect } from 'react-redux';
import { getMediaQueries } from '../../store/selectors/responsive';

const withMediaQueries = connect(state => ({
  media: getMediaQueries(state),
}));

export default withMediaQueries;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withMediaQueries.js